import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function NavbarItem({ navItems = [] }) {
  const location = useLocation();
  const basePath = process.env.PUBLIC_URL || '';

  const handleAnchorClick = (e, link) => {
    if (!link.startsWith('#')) return;
    e.preventDefault();
    const targetId = link.substring(1);
    window.location.hash = link;
    const scrollToElement = () => {
      const el = document.getElementById(targetId);
      if (el) {
        const headerOffset = 120;
        const offsetPosition = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: Math.max(0, offsetPosition), behavior: 'smooth' });
      }
    };
    scrollToElement();
    setTimeout(scrollToElement, 100);
    setTimeout(scrollToElement, 300);
  };

  return navItems.map((item) => {
    const isExternal = item.external === true;
    const isAnchor = (item.link || '').toString().startsWith('#');
    const isActive = location.pathname === `${basePath}${item.link}`;

    const linkStyle = {
      fontWeight: isActive ? '500' : '300',
      letterSpacing: isActive ? '-0.33px' : 'inherit',
      color: isActive ? '#E12426' : 'inherit',
    };

    return (
      <li
        key={item.id}
        className={`${item.subMenu || item.megaMenu ? 'has-submenu' : ''} ${isActive ? 'active' : ''}`}
      >
        {isExternal ? (
          <a href={item.link} rel="noopener noreferrer" style={linkStyle}>
            {item.title}
          </a>
        ) : isAnchor ? (
          <a href={item.link} style={linkStyle} onClick={(e) => handleAnchorClick(e, item.link)}>
            {item.title}
          </a>
        ) : (
          <Link to={`${basePath}${item.link}`} style={linkStyle}>
            {item.title}
          </Link>
        )}
        {item.subMenu && (
          <ul className="submenu-nav">
            {item.subMenu.map((subItem, index) => (
              <li key={index}>
                <Link to={`${basePath}${subItem.link}`}>{subItem.title}</Link>
              </li>
            ))}
          </ul>
        )}
        {item.megaMenu && (
          <ul className="submenu-nav submenu-nav-mega">
            {item.megaMenu.map((megaItem, indx) => (
              <li key={indx} className="mega-menu-item">
                <Link to={megaItem.link}>{megaItem.title}</Link>
                <ul>
                  {megaItem.lists?.map((listItem, idx) => (
                    <li key={idx}>
                      <Link to={`${basePath}${listItem.link}`}>{listItem.title}</Link>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  });
}

export default NavbarItem;
